export class RtfNumberingListOverride {
    constructor() {
        this.levels = [];
    }
}
